import Store from '@/entity/Store';
export default class StoreOperationSettingVM extends Store {
    /**
     * @param Store domain store
     */
    // eslint-disable-next-line no-useless-constructor
    constructor(store) {
        super(store);
    }
}
